
    <h1 mat-dialog-title style="text-align:center;">Final Inspection Checklist Warnings</h1>
    <div>
      <p>This is a final, please make sure all of the checklist items are at least filled in with 'N/A.'</p>
      <div *ngFor="let item of data;" style="border-style: solid;border-width: 0.5px; padding-left: 6px;">
        <pre style="white-space: break-spaces;">{{item}}</pre>
      </div>
    </div>
    <div style="position: relative;margin-top: 10px;top: 20px;left: 42px;width: 70%;">
      <button mat-button (click)="dref.close()"  style="position: relative;left: 50%;background: #ffffffaf;">Close</button>
    </div>
  